<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/requisicaoServico', query: $route.query }">
        Compras/Requisição/Requisição
      </router-link>
      <label class="labelBar"> / </label>
      <label> Aprovar Requisição Serviço</label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Unidade Administrativa"
              v-model="unidadeAdm"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Local de Entrega"
              v-model="local"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Requisitante"
              v-model="requisitante"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Prioridade"
              v-model="prioridade"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Nº Requisição"
              v-model="requisicaoServico.nome"
              :counter="200"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-textarea
              label="Observação"
              auto-grow
              v-model="observacao" v-uppercase
              rows="1"
              readonly
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="6">
            <v-textarea
              label="Observação do Aprovador"
              auto-grow
              v-model="observacaoAprovador"
              maxlength="200"
              counter
              rows="1"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="fornecedorSelected"
              :items="filteredFornecedor"
              label="Fornecedor *"
              item-text="nome"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Fornecedor é obrigatório']"
              required
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-snackbar v-model="errorMessage" color="error" timeout="5000"
          >{{ errorMessageValue }}
        </v-snackbar>
      </v-form>
      <v-card>
        <v-data-table :headers="headers" hide-default-footer :items-per-page="-1" :items="produtosL">
          <template v-slot:item.autorizado="{ item }">
            {{ item.quantidadeAprovada > 0 ? "Sim" : "Não" }}
          </template>
          <template v-slot:item.quantidadeAprovada="{ item }">
            <v-text-field
              v-model="item.quantidadeAprovada"
              type="number"
              v-mask="['#####']"
              :rules="[validarQuantidadeAprovada(item)]"
              required
            >
            </v-text-field>
          </template>
        </v-data-table>
      </v-card>

      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn
            @click="desfazer"
            color="primary"
            class="mr-4"
            :disabled="requisicaoServico.status != 'PA'"
          >
            Desaprovar
          </v-btn>
          <v-btn
            @click="declinar"
            :disabled="(requisicaoServico.status == 'D' && !isAdmin()) || !isInactive(idModulo)"
            color="secondary"
            class="mr-4"
          >
            Declinar
          </v-btn>
          <v-btn
            :to="{ path: '/requisicaoServico', query: $route.query }"
            color="error"
            class="mr-4"
          >
            Voltar
          </v-btn>
          <v-btn
            @click="aprovar"
            color="success"
            class="mr-4"
            :loading="overlay"
            :disabled="
              overlay ||
              (requisicaoServico.status != 'AA' &&
                requisicaoServico.status != 'D') ||
              !isApproving(idModulo)
            "
          >
            Aprovar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import {
  aprovarRequisicaoAsync,
  declinarRequisicaoAsync,
  desautorizarRequisicaoAsync,
  obterRequisicaoPorIdAsync,
} from "../../../services/requisicaoServicoService";
import { mapState, mapActions } from "vuex";
import {
  canApproveModule,
  canDeclineModule,
  getUserRoles,
  isLoggedUserAdmin,
  logApprovalDiagnostics,
  explainApprovalButtonState,
} from "@/services/loginService";

export default {
  name: "aprovarRequisicao",
  data: () => ({
    idModulo: 8,
    prioridade: null,
    overlay: false,
    valid: true,
    id: null,
    requisitante: null,
    idOrdemServico: null,
    descricao: null,
    observacao: null,
    observacaoAprovador: null,
    autorizado: null,
    local: null,
    unidadeAdm: null,
    fornecedorSelected: null,
    produtosL: [],
    indexEdit: null,
    errorMessage: false,
    errorMessageValue: null,
    headers: [
      { text: "ID", value: "id", sortable: false },
      { text: "Item", value: "descricao", sortable: false },
      { text: "Cod. Fabricante", value: "codigo", sortable: false },
      { text: "Qtd.", value: "quantidade", sortable: false },
      { text: "Und.", value: "unidadeMedida", sortable: false },
      {
        text: "Qtd. Aprv.",
        value: "quantidadeAprovada",
        width: "10%",
      },
      { text: "Aprov.?", value: "autorizado", sortable: false },
      { text: "Centro de Custo", value: "centroCusto", sortable: false },
      { text: "Detalhamento", value: "observacao", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState("requisicaoServico", ["requisicaoServico"]),
    ...mapState("fornecedor", ["fornecedores"]),

    filteredFornecedor() {
      return this.fornecedores
        .filter((f) => {
          return f.ativo === true;
        })
        .sort(function (a, b) {
          return b.id - a.id;
        });
    },
  },
  methods: {
    ...mapActions("requisicaoServico", [
      "atualizarRequisicaoServico",
      "updateRequisicaoServico",
    ]),
    ...mapActions("fornecedor", ["atualizarFornecedores"]),
    isApproving(id) {
      const pode = canApproveModule(id);
      logApprovalDiagnostics("RequisicaoServico/Aprovar:Aprovar", explainApprovalButtonState({
        modulo: id,
        registro: this.requisicaoServico,
        action: "aprovar",
        statusPermitidos: ["AA"],
      }));
      return pode;
    },
    isInactive(id) {
      const pode = canDeclineModule(id);
      logApprovalDiagnostics("RequisicaoServico/Aprovar:Declinar", explainApprovalButtonState({
        modulo: id,
        registro: this.requisicaoServico,
        action: "declinar",
        statusPermitidos: ["AA", "PA", "D"],
      }));
      return pode;
    },
    isAdmin() {
      return isLoggedUserAdmin();
    },
    async aprovar() {
      if (this.overlay) {
        return;
      }

      const produtosNormalizados = this.normalizarProdutosParaAprovacao();
      const idFornecedor = Number(this.fornecedorSelected?.id);

      if (!Number.isInteger(idFornecedor) || idFornecedor <= 0) {
        this.errorMessageValue = "Selecione um fornecedor válido.";
        this.errorMessage = true;
        this.$refs.form.validate();
        return;
      }

      if (this.$refs.form.validate()) {
        if (produtosNormalizados.length === 0) {
          this.errorMessageValue =
            "A requisição de serviço não possui itens para aprovação.";
          this.errorMessage = true;
          return;
        }

        this.errorMessage = false;
        for (let i = 0; i < produtosNormalizados.length; i++) {
          const quantidadeAprovada = produtosNormalizados[i].quantidadeAprovada;
          if (
            !Number.isInteger(quantidadeAprovada) ||
            produtosNormalizados[i].quantidade < quantidadeAprovada ||
            quantidadeAprovada < 0
          ) {
            this.errorMessageValue =
              "A quantidade deve ser entre 0 até a mesma quantidade requisitada!";
            this.errorMessage = true;
            break;
          }
        }
        //if ( this.produtosL.filter((p) => {
        //    return p.quantidadeAprovada > 0;
        //  }).length == 0 && !this.errorMessage )
        //  {
        //  this.errorMessageValue = "Gentileza alterar a quantidade de itens que estão sendo aprovados!";
        //  this.errorMessage = true;
        //}
        if (this.errorMessage) {
          return;
        }
        this.errorMessage = true;
        this.errorMessageValue =
          "A quantidade de pelo menos 1 dos items deve ser maior que zero!";
        for (let i = 0; i < produtosNormalizados.length; i++) {
          if (produtosNormalizados[i].quantidadeAprovada > 0) {
            this.errorMessage = false;
            break;
          }
        }
        if (this.errorMessage) {
          return;
        }
        this.overlay = true;
        try {
          const resposta = await aprovarRequisicaoAsync(
            this.requisicaoServico.id,
            this.observacaoAprovador,
            produtosNormalizados,
            idFornecedor
          );
          if (!resposta || resposta?.status != 200) {
            //this.mensagemErro = resposta;
            //this.mostartMensagemErro = true;
            this.$alert(
              resposta.message,
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            this.updateRequisicaoServico(
              this.mountObjRequisicao(resposta.data)
            );
            this.$store.dispatch("ui/showSnackbar", {
              text: "Requisição de serviço aprovada!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push({
              path: "/requisicaoServico",
              query: this.$route.query,
            });
          }
        } finally {
          this.overlay = false;
        }
      }
      /*if (this.produtosL == null || this.produtosL.length <= 0) {
        this.errorMessage = true;
      } else if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await aprovarRequisicaoAsync(
          this.requisicao.id
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$router.push("/requisicao");
        }
      }*/
    },

    async declinar() {
      try {
        await this.$confirm(
          "Tem certeza que deseja declinar os itens? Todos serão cancelados.",
          "Confirmação",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Não",
            type: "warning",
          }
        );
        this.overlay = true;
        try {
          const resposta = await declinarRequisicaoAsync(
            this.requisicaoServico.id,
            this.observacaoAprovador
          );
          if (!resposta || resposta?.status != 200) {
            this.$alert(
              resposta.message,
              "Descupe, falha na operação!",
              "error"
            );
          } else {
            this.updateRequisicaoServico(this.mountObjRequisicao(null));
            this.$store.dispatch("ui/showSnackbar", {
              text: "Requisição de serviço declinada!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push({
              path: "/requisicaoServico",
              query: this.$route.query,
            });
          }
        } finally {
          this.overlay = false;
        }
      } catch (e) {
        void e;
      }
    },
    async desfazer() {
      try {
        await this.$confirm(
          "Tem certeza que deseja desaprovar os itens? Os mesmos voltarao para o status inicial de Aguardando autorizacao.",
          "Confirmação",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Não",
            type: "warning",
          }
        );
        for (var i = 0; i < this.produtosL.length; i++) {
          this.produtosL[i].quantidadeAprovada = 0;
        }
        this.observacaoAprovador = null;
        this.fornecedorSelected = null;
        this.overlay = true;

        try {
          const resposta = await desautorizarRequisicaoAsync(
            this.requisicaoServico.id,
            this.observacaoAprovador,
            this.produtosL
          );
          if (!resposta || resposta?.status != 200) {
            this.$alert(
              resposta.message,
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            this.updateRequisicaoServico(
              this.mountObjRequisicao(resposta.data)
            );
            this.$store.dispatch("ui/showSnackbar", {
              text: "Requisição de serviço desaprovada!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push({
              path: "/requisicaoServico",
              query: this.$route.query,
            });
          }
        } finally {
          this.overlay = false;
        }
      } catch (e) {
        void e;
      }
    },

    mountObjRequisicao(obj) {
      return {
        ...this.requisicaoServico,
        ...(obj || {}),
        status: obj == null ? "D" : obj.status,
        produtos: obj?.produtos || obj?.Produtos || this.produtosL,
        observacaoAutorizador: this.observacaoAprovador,
        idFornecedor:
          this.fornecedorSelected != null ? this.fornecedorSelected.id : 0,
      };
    },
    validarQuantidadeAprovada(item) {
      return (valor) => {
        const quantidadeAprovada = Number(valor);
        return (
          (!Number.isNaN(quantidadeAprovada) &&
            quantidadeAprovada >= 0 &&
            quantidadeAprovada <= item.quantidade) ||
          "A quantidade deve ser 0 até a quantidade requisitada!"
        );
      };
    },

    normalizarProdutosParaAprovacao() {
      return (this.produtosL || []).map((item) => {
        const valorAtual = item.quantidadeAprovada;
        const semValor =
          valorAtual === null ||
          valorAtual === undefined ||
          (typeof valorAtual === "string" && valorAtual.trim() === "");
        const quantidadeAprovada = semValor
          ? Number(item.quantidade)
          : Number(valorAtual);

        this.$set(item, "quantidadeAprovada", quantidadeAprovada);
        this.$set(item, "autorizado", quantidadeAprovada > 0);

        return {
          ...item,
          quantidade: Number(item.quantidade),
          quantidadeAprovada,
          autorizado: quantidadeAprovada > 0,
        };
      });
    },

    findFornecedor(fornecedorId) {
      return this.filteredFornecedor.find((f) => f.id === fornecedorId);
    },
    async carregarTela() {
      this.overlay = true;
      try {
        if (!this.fornecedores || this.fornecedores.length === 0) {
          await this.atualizarFornecedores();
        }

        const idRota = Number(this.$route.query.id);
        if (idRota > 0) {
          const resposta = await obterRequisicaoPorIdAsync(idRota);
          if (!resposta || resposta.status !== 200) {
            this.$router.push("/requisicaoServico");
            return;
          }
          this.atualizarRequisicaoServico(resposta.data);
        }

        if (!this.requisicaoServico?.id) {
          this.$router.push("/requisicaoServico");
          return;
        }

        this.inicializarCampos();
      } finally {
        this.overlay = false;
      }
    },
    inicializarCampos() {
      let index = 0;
      this.prioridade =
        this.requisicaoServico.prioridade === "Normal" ||
        this.requisicaoServico.prioridade === 1
          ? "Normal"
          : "Emergencial";
      this.id = this.requisicaoServico.id;
      this.requisitante = this.requisicaoServico.requisitante;
      this.idOrdemServico =
        this.requisicaoServico.idOrdemServico == null ||
        this.requisicaoServico.idOrdemServico == 0
          ? "NA"
          : this.requisicaoServico.idOrdemServico;
      this.produtosL = JSON.parse(
        JSON.stringify(this.requisicaoServico.produtos || [])
      );
      this.autorizado = this.requisicaoServico.autorizado;
      this.unidadeAdm = this.requisicaoServico.unidadeAdm;
      this.local = this.requisicaoServico.local;
      this.observacao = this.requisicaoServico.observacao;
      this.observacaoAprovador =
        this.requisicaoServico.observacaoAutorizador;
      this.fornecedorSelected = this.findFornecedor(
        this.requisicaoServico.idFornecedor
      );

      for (let i = 0; i < this.produtosL.length; i++) {
        this.$set(this.produtosL[i], "index", index++);
        const quantidadeAprovadaAtual = Number(
          this.produtosL[i].quantidadeAprovada
        );
        const deveSugerirQuantidade =
          ["AA", "D"].includes(this.requisicaoServico.status) &&
          (this.produtosL[i].quantidadeAprovada === null ||
            this.produtosL[i].quantidadeAprovada === undefined ||
            quantidadeAprovadaAtual === 0);
        this.$set(
          this.produtosL[i],
          "quantidadeAprovada",
          deveSugerirQuantidade
            ? this.produtosL[i].quantidade
            : Number.isNaN(quantidadeAprovadaAtual)
            ? 0
            : quantidadeAprovadaAtual
        );
      }
      const roles = getUserRoles();
      if (roles) {
        this.regras = roles;
      }
    },
  },
  created: function () {
    this.carregarTela();
  },
};
</script>
